import { Facepile } from 'office-ui-fabric-react';
import styled, * as sc from 'styled-components';

const personaStyles: sc.CSSObject = {
  border: '2px solid white',
  ul: {
    overflow: 'visible',
  },
  'li:nth-child(n+2) > div': {
    border: '2px solid white',
    position: 'relative',
  },
};
Array.from(Array(4)).forEach((a, i) => [
  (personaStyles[`li.ms-Facepile-member:nth-child(${i + 1}) > div`] = {
    left: `calc(-66% * ${i})`,
    top: `calc(15% * ${i})`,
  }),
]);

export const PeopleDetailFacePile = styled(Facepile)(personaStyles);
